import { useParams, useLocation } from 'react-router-dom';
import Lobby from '../components/lobby/Lobby';
import Conference from '../components/room/Conference';
import { useRoomStore } from '../stores/roomStore';

const Room = () => {
  const { roomId } = useParams<{ roomId: string }>();
  const location = useLocation();
  const { inLobby, joinedRoom } = useRoomStore();
  
  const displayName = location.state?.displayName || localStorage.getItem('displayName') || '';
  const isHost = location.state?.isHost || false;
  const password = location.state?.password || undefined;
  const createRoom = location.state?.createRoom || false;

  if (!roomId) {
    return <div>Room ID not found</div>;
  }

  return (
    <div className="h-screen bg-gray-900">
      {inLobby ? (
        <Lobby 
          roomId={roomId} 
          displayName={displayName}
          isHost={isHost}
          initialPassword={password}
          createRoom={createRoom}
        />
      ) : joinedRoom ? (
        <Conference />
      ) : (
        <div className="flex items-center justify-center h-full">
          <div className="text-white text-xl">Подключение...</div>
        </div>
      )}
    </div>
  );
};

export default Room;
